export default { 
    SET_INFLUENCER (state, val) {
        state.influencer = val
    }
}